import React from 'react';

// Components
import Card from '.';
import CaseStudyCard from './CaseStudyCard';
// Interfaces
import {
  Card as CardInterface,
  CaseStudyCard as CaseStudyCardInterface,
} from '../../interfaces/card';

interface CardsProps {
  data: {
    cards: Array<CardInterface> | Array<CaseStudyCardInterface>;
    slider: boolean;
    columnSpan: number;
    extraClasses: string;
  };
}
function Cards({ data }: CardsProps) {
  const { cards, columnSpan, extraClasses } = data;

  return (
    <div className={`cl-row ${extraClasses ? extraClasses : ''}`}>
      {cards &&
        cards.map((card, index: number) => {
          return (
            <React.Fragment key={index}>
              {card.sys.contentType.sys.id === 'caseStudyCard' ? (
                <CaseStudyCard card={card} columnSpan={columnSpan} />
              ) : (
                <Card card={card} columnSpan={columnSpan} />
              )}
            </React.Fragment>
          );
        })}
    </div>
  );
}

export default Cards;
